import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../context/LangContext";
import { BOOK_PATH, FIT_LIST, STRINGS } from "../../data/content";

export default function FitSection() {
  const { t } = useLang();
  return (
    <section className="section fit-section">
      <div className="section-inner">
        <h2 className="section-title fade-in">{t(STRINGS.fitTitle)}</h2>
        <div className="fit-list">
          {FIT_LIST.map((item) => (
            <div className="fit-item fade-in" key={item.id}>
              <span className="check">✓</span>
              <span>{t(item)}</span>
            </div>
          ))}
        </div>
        <div className="fade-in" style={{ marginTop: 48 }}>
          <Link to={BOOK_PATH} className="btn btn-inverse">
            {t(STRINGS.bookCallFree)}
          </Link>
        </div>
      </div>
    </section>
  );
}
